import React, { Children } from 'react'
import { OverlayStyle } from './styles'

export interface OverlayLoadingProps {
  children?: React.ReactNode
}

export interface OverlayLoadingDrawerHandle {
  handleOpen: () => void
  handleClose: () => void
}

const OverlayLoading: React.ForwardRefRenderFunction<
  OverlayLoadingDrawerHandle,
  OverlayLoadingProps
> = ({ children }, ref) => {
  const [open, setOpen] = React.useState(false)

  React.useImperativeHandle(ref, () => ({
    handleOpen() {
      setOpen(true)
    },
    handleClose() {
      setOpen(false)
    },
  }))

  if (!open) return <></>

  return (
    <OverlayStyle.Container>
      <OverlayStyle.Inner>
        <OverlayStyle.InnerContent>
          <OverlayStyle.Spinner />
        </OverlayStyle.InnerContent>
        {children && <OverlayStyle.InnerContentText>{children}</OverlayStyle.InnerContentText>}
      </OverlayStyle.Inner>
    </OverlayStyle.Container>
  )
}

export default React.forwardRef(OverlayLoading)
